module.exports = __webpack_public_path__ + "assets/img/center_icon06.0d73be48.svg";